/**
 * Extracts a typed document payload from a write-back row.
 *
 * Delegates to {@link CandidDocumentWritebackPayload.parse}, which unwraps
 * the journal envelope and remaps `gcs_path` to `document_gcs_path`.
 *
 * @module getDocumentPayload
 */
import { CandidDocumentWritebackPayload } from "../../../../../data-model/candidDocumentWritebackPayload";
import {
  CandidDocumentPayload,
  CandidWritebackRecord,
} from "../types/candidWriteback";

/**
 * Returns the first document body from a write-back row, if present.
 *
 * @param record - Write-back row whose `use_case` is document
 * @returns Document payload, or null when missing
 */
export const getDocumentPayload = (
  record: CandidWritebackRecord,
): CandidDocumentPayload | null => {
  if (!record.payload) {
    return null;
  }
  return CandidDocumentWritebackPayload.parse(record.payload);
};
